import { ExternalConnection, ID } from '@griply/types';

import { canConnectionWriteEvents } from './can-connection-write-events';

// Structural rather than ExternalCalendarEvent, so a CalendarEventRef (which carries the same
// pair, non-optional) resolves through the same gate as a grid event.
export type ExternalEventEditableTarget = {
  connectionId?: ID;
  calendarId?: ID;
};

export type GetExternalEventEditableOptions = {
  connections: ExternalConnection[];
  // absent on a backend deployed before RSVP support, where every event reads as your own —
  // only an explicit `false` means you were invited rather than organising
  isOrganizer?: boolean;
};

// Deliberately connection-level, not calendar-level: the per-calendar `canWrite` flag lives
// behind the calendars callables, which are only fetched while the event popup is open so a
// grid render never fans them out. A drag onto a read-only calendar therefore fails at the
// provider and rolls back optimistically rather than being blocked up front.
export const getExternalEventEditable = (
  target: ExternalEventEditableTarget,
  { connections, isOrganizer }: GetExternalEventEditableOptions,
): boolean => {
  if (!target.connectionId || !target.calendarId) {
    return false;
  }
  if (isOrganizer === false) {
    return false;
  }

  const connection = connections.find(({ id }) => id === target.connectionId);

  return !!connection && canConnectionWriteEvents(connection);
};
